module.exports = __webpack_public_path__ + "static/media/29BDOS28.b36637ef.jpg";